import React from 'react';

import { Header } from './components/br24/header/Header';
import { Date } from './components/br24/date/Date';
import { Authors } from './components/br24/authors/Authors';
import { Quote } from './components/custom/quote/Quote';
import { Position } from './config/models';
import { MobileFoldable } from './components/br24/foldable/Foldable';
import { mainConfig } from './config/config.provider';
import { Teaser } from './components/br24/relatedContent/RelatedContent';
import { RelatedContent } from './components/br24/relatedContent/styles.RelatedContent';
import { LazyLoadComponent } from 'react-lazy-load-image-component';
import { LazyImage } from './components/custom/lazyImage/LazyImage';
import { Paper } from './components/custom/paper/Paper';
import { InfoBox } from './components/custom/infoBox/InfoBox';
import { Article, Section, Block, H1, H2, P, A, Strong, List, ListItem } from './styles/styledComponents';
import { changeLang } from './utils/helper/helpers';
import { Scrolly, Slide } from './interactives/scrolly/Scrolly';
import { Main3DSzene } from './interactives/3DSzene/Main';
import { boardConfig } from './config/boardConfig';
import { Empty } from './components/custom/scrollyteller/styles.ScrollyTeller';

import ImageScanner from './assets/images/scanner.jpg';
import ImageMatthias from './assets/images/matthias.jpg';
import ImageMatthiasLaptop from './assets/images/matthias-laptop.jpg';
import ImageOriginalScreen from './assets/images/original-screen.png';
import ImageSaid from './assets/images/said.jpg';

export const Content = () => {
    return (
        <Article id="main-article">
            <Main3DSzene />
            <Header />
            <MobileFoldable triggerText={mainConfig.headerInfo}>{mainConfig.headerCredits}</MobileFoldable>

            <Section id="initial-section">
                <Block isOverlay={mainConfig.headerOverlay}>
                    <Date day={27} month={12} year={2022} time="06:00" />
                    {!mainConfig.titleInHeader ? <H1>{mainConfig.title}</H1> : null}
                    <P>
                        <Strong>{mainConfig.headline}</Strong>
                    </P>
                    <Authors />
                    <List>
                        {mainConfig.provideEn ? (
                            <ListItem>
                                To read the english version of this article, <A onClick={changeLang}>click here</A>
                            </ListItem>
                        ) : null}
                        <ListItem>
                            Zum ausführlichen{' '}
                            <A
                                href="https://www.ardaudiothek.de/sendung/das-ard-radiofeature/72633432/"
                                rel="noopener noreferrer"
                                target="_blank"
                            >
                                ARD-Radiofeature
                            </A>{' '}
                        </ListItem>
                    </List>
                    <P>
                        US-Truppen und ihre Verbündeten haben in Afghanistan Millionen von Menschen biometrisch erfasst
                        - mit tausenden Biometrie-Geräten. Nach dem chaotischen Abzug der internationalen Truppen im
                        August 2021 blieben offenbar viele Geräte zurück. Expertinnen und Experten befürchten, dass die
                        Taliban diese einsetzen könnten, um Menschen zu identifizieren, an denen sie sich rächen wollen.
                        Ob das tatsächlich möglich ist, war nicht belegt. Bis jetzt.
                    </P>
                </Block>
            </Section>

            <Scrolly skipLazyLoad={true}>
                <Slide
                    position={Position.RIGHT}
                    trigger={{
                        camera: boardConfig.cameraConfigs['scanner'],
                        transform: [boardConfig.assetTransformations['scanner']['initial']],

                        changeMaterial: { meshId: 'display', materialName: 'display/scanner_display_home.jpg' }
                    }}
                >
                    Die Geräte, die zur Gefahr für verfolgte Afghaninnen und Afghanen werden können, sehen unscheinbar
                    aus: Schwarz, 13 cm breit, 20 cm lang, mit einem Display und mehreren Kameras.
                </Slide>
                <Empty
                    trigger={{
                        fade: ['human', 'head'],
                        animate: [{ name: 'display_coverAction.001' }]
                    }}
                />
                <Slide
                    position={Position.RIGHT}
                    trigger={{
                        camera: boardConfig.cameraConfigs['finger'],
                        transform: [boardConfig.assetTransformations['scanner']['finger']],
                        animate: [{ name: 'fingerprint_coverAction' }, { name: 'humanAction' }]
                    }}
                >
                    Alle zehn Fingerabdrücke einer Person können auf den Geräten gespeichert werden, indem man jeden
                    Finger einzeln auf eine Sensor-Glasplatte auf der Oberseite des Geräts drückt.
                </Slide>
                <Empty
                    trigger={{
                        camera: boardConfig.cameraConfigs['display_finger'],
                        changeMaterial: {
                            meshId: 'display',
                            materialName: 'display/scanner_display_fingerprint.jpg'
                        }
                    }}
                />
                <Slide
                    position={Position.LEFT}
                    trigger={{
                        camera: boardConfig.cameraConfigs['picture'],
                        transform: [boardConfig.assetTransformations['scanner']['picture']],
                        changeMaterial: { meshId: 'display', materialName: 'display/scanner_display_photo.jpg' }
                    }}
                >
                    Mit einer eingebauten Kamera lassen sich biometrische Gesichtsbilder aufnehmen.
                </Slide>

                <Slide
                    position={Position.RIGHT}
                    trigger={{
                        camera: boardConfig.cameraConfigs['eyes'],
                        animate: [{ name: 'humanAction', action: 'reverse' }],
                        transform: [boardConfig.assetTransformations['scanner']['eyes']]
                    }}
                >
                    Hält man die Vorderseite des Geräts nah an die Augen, scannt eine weitere Kamera die Muster der
                    Iris. Sie sind für jeden Menschen einzigartig.
                </Slide>
                <Empty
                    trigger={{
                        camera: boardConfig.cameraConfigs['display_eyes'],
                        changeMaterial: { meshId: 'display', materialName: 'display/scanner_display_iris.jpg' }
                    }}
                />
                <Slide
                    position={Position.RIGHT}
                    trigger={{
                        changeMaterial: { meshId: 'display', materialName: 'display/scanner_display_database.jpg' }
                    }}
                >
                    Die biometrischen Daten werden auf dem Gerät gespeichert.
                </Slide>
                <Slide
                    position={Position.LEFT}
                    trigger={{
                        camera: boardConfig.cameraConfigs['keyboard_eyes'],

                        changeMaterial: { meshId: 'display', materialName: 'display/scanner_display_photo.jpg' }
                    }}
                >
                    Über die Tastatur lassen sich weitere Informationen eintragen wie Geburtsdatum, Größe, Nationalität
                    und der Grund, wieso die Person erfasst wurde. Solche Informationen haben Nato-Truppen im großen
                    Stil in Afghanistan erfasst und auf den Geräten gespeichert.
                </Slide>

                <Slide
                    position={Position.RIGHT}
                    trigger={{
                        camera: boardConfig.cameraConfigs['info'],
                        transform: [boardConfig.assetTransformations['scanner']['initial']],
                        fade: ['info'],
                        changeMaterial: {
                            meshId: 'display',
                            materialName: 'display/scanner_display_identification.jpg'
                        }
                    }}
                >
                    Wird dieselbe Person später erneut gescannt (Augen, Finger oder Gesicht), erkennt das Gerät sie
                    wieder und zeigt alle Daten auf dem Display an.
                </Slide>
                <Slide
                    position={Position.RIGHT}
                    trigger={{
                        camera: boardConfig.cameraConfigs['scanner'],
                        changeMaterial: { meshId: 'display', materialName: 'display/scanner_display_persons.jpg' },
                        animate: [
                            { name: 'humanAction', action: 'reverse' },
                            { name: 'fingerprint_coverAction', action: 'reverse' }
                        ],
                        fade: ['info', 'human', 'head']
                    }}
                >
                    Im schlimmsten Fall könnten die Taliban so Menschen finden, die für Nato-Truppen, die ehemalige
                    afghanische Polizei oder das Militär gearbeitet haben.
                </Slide>
            </Scrolly>

            <Section>
                <Block>
                    <Quote author="Shir Entezar" position={Position.RIGHT}>
                        Jede Nacht und jeden Tag suchen sie nach uns. Wir sind in Gefahr, hingerichtet, gefoltert oder
                        eingesperrt zu werden.
                    </Quote>
                    <P>
                        „Jede Nacht und jeden Tag suchen sie nach uns. Wir sind in Gefahr, hingerichtet, gefoltert oder
                        eingesperrt zu werden.“ Shir Entezar ist auf der Flucht. Früher hat er in Afghanistan für die
                        Deutschen gearbeitet. Im Auftrag der Bundesregierung unterrichtete er afghanische Polizistinnen
                        und Polizisten, brachte ihnen Lesen und Schreiben bei. Nachdem die Taliban die Macht übernommen
                        hatten, musste er fliehen. Als er sich bei uns meldet, versteckt er sich mit seiner Familie seit
                        neun Monaten, irgendwo in Afghanistan, fernab seiner Heimat.
                    </P>

                    <P>
                        „Sie suchen nach Leuten, die der Polizei geholfen haben, und vor allem nach denen, die für
                        westliche Staaten gearbeitet haben, wie Deutschland oder die USA.“ Früher hätte er mit seiner
                        Familie vielleicht in einer anderen Provinz untertauchen können, wo ihn niemand kennt. Heute
                        reicht das in Afghanistan nicht mehr. Denn seine biometrischen Daten, erfasst im Rahmen seiner
                        Arbeit für die Deutschen, könnten ihn jederzeit und an jedem Ort verraten. Ob die Taliban auf
                        diese Daten zugreifen können, kann er nicht mit Sicherheit sagen. Aber er befürchtet es.
                    </P>
                    <H2>Biometrie-Geräte auf Ebay zum Verkauf</H2>
                    <P>
                        Als wir im März 2022 zum ersten Mal mit dem IT-Experten Matthias Marx sprechen, hat auch er
                        davon gehört, dass die Taliban Menschen mit Biometrie-Scannern der westlichen Truppen verfolgen
                        könnten. Er lebt in Hamburg und ist Mitglied des Chaos Computer Clubs. Mehr als 100 schwere
                        Sicherheitslücken habe er entdeckt und gemeldet, erzählt er uns. Besonders interessiert ihn das
                        Thema Biometrie.
                    </P>
                    <LazyImage
                        src={ImageMatthias}
                        width={900}
                        height={675}
                        note="IT-Experte Matthias Marx zeigt Biometrie-Geräte. Bild: NDR/Svea Eckert"
                    />
                    <P>
                        Er zeigt uns zwei Biometrie-Geräte des US-Militärs. Die hat er im Internet entdeckt – und zwar
                        auf der Auktionsplattform Ebay. Bei Shops in den USA, die die unterschiedlichsten ausgemusterten
                        Dinge anbieten, wie Unterwasser-Metalldetektoren oder Präzisionsthermometer. Vieles davon
                        scheint aus alten Militärbeständen zu stammen. Mit technischen Analysen will Matthias Marx die
                        Frage beantworten, über die in Berichten aus Afghanistan spekuliert wird: Ob die Taliban
                        tatsächlich Biometrie-Geräte, die die internationalen Truppen zurückgelassen haben, einsetzen
                        können, um Menschen zu identifizieren. Er fasst einen Plan.
                    </P>
                    <P>
                        Wenige Wochen später trifft er sich mit einer Gruppe von IT-Experten des Chaos Computer Clubs in
                        Berlin, um die Geräte zu untersuchen. Auch wir sind dabei. Die Hacker wollen klären: Sind die
                        Daten verschlüsselt? Gibt es einen Passwortschutz? Befinden sich auf ihnen noch Daten, mit denen
                        die Taliban Menschen identifizieren könnten?
                    </P>
                </Block>
            </Section>

            <Scrolly>
                <Slide
                    position={Position.RIGHT}
                    trigger={{
                        changeMaterial: { meshId: 'display', materialName: 'display/scanner_display_login.jpg' },
                        camera: boardConfig.cameraConfigs['keyboard_initial'],
                        fade: ['highlight_key_1', 'highlight_key_2'],
                        animate: [
                            { name: 'highlight_key_1', mode: 'LoopPingPong', repetitions: Infinity },
                            { name: 'highlight_key_2', mode: 'LoopPingPong', repetitions: Infinity }
                        ]
                    }}
                >
                    Schnell finden die IT-Experten heraus: Eine Verschlüsselung, die Daten vor fremdem Zugriff schützen
                    könnte, gibt es nicht. Auch der Passwortschutz lässt sich leicht umgehen. Wie, steht in der
                    beiliegenden Anleitung. Es reicht, zwei Tasten zu drücken.
                </Slide>

                <Slide
                    position={Position.LEFT}
                    trigger={{
                        changeMaterial: { meshId: 'display', materialName: 'display/scanner_display_home.jpg' },
                        camera: boardConfig.cameraConfigs['keyboard_initial_close']
                    }}
                >
                    „Man könnte das Passwort auch weglassen“, sagt Matthias Marx. „Taliban könnten diese Geräte sofort
                    einsetzen. Es gibt praktisch keine Hürde.“
                </Slide>

                <Slide
                    position={Position.RIGHT}
                    trigger={{
                        camera: boardConfig.cameraConfigs['display_initial'],
                        changeMaterial: { meshId: 'display', materialName: 'display/scanner_display_soldier.jpg' },
                        animate: [
                            { name: 'highlight_key_1', action: 'stop' },
                            { name: 'highlight_key_2', action: 'stop' }
                        ]
                    }}
                >
                    Daten von Menschen aus Afghanistan finden die Hacker zu diesem Zeitpunkt noch nicht. Aber einen
                    Hinweis, dass die untersuchten Geräte tatsächlich vom US-Militär stammen.
                </Slide>

                <Slide position={Position.LEFT} trigger={{}}>
                    Auf einem der Geräte befinden sich die Namen, Fotos, Fingerabdrücke und Iris-Scans von zwei
                    US-Soldaten. Einer ist offenbar ein Geheimdienstoffizier der US-Marines.
                </Slide>

                <Slide
                    position={Position.RIGHT}
                    trigger={{
                        changeMaterial: { meshId: 'display', materialName: 'display/scanner_display_jordan.jpg' },
                        camera: boardConfig.cameraConfigs['display_initial_close']
                    }}
                >
                    Die Hacker finden noch mehr: Koordinaten, die auf einen Punkt in Jordanien zeigen.
                </Slide>
                <Slide
                    position={Position.RIGHT}
                    trigger={{
                        camera: boardConfig.cameraConfigs['display_initial_close'],
                        changeMaterial: { meshId: 'display', materialName: 'display/scanner_display_connection.jpg' }
                    }}
                >
                    Am Ende der Untersuchung erleben die Hacker eine Überraschung: Das Gerät versucht, eine
                    Internetverbindung aufzubauen. Offenbar zur zentralen Biometrie-Datenbank des
                    US-Verteidigungsministeriums.
                </Slide>
                <Slide
                    position={Position.RIGHT}
                    trigger={{
                        camera: boardConfig.cameraConfigs['data'],
                        fade: ['server_1', 'laptop']
                    }}
                >
                    Die Server des “Automated Biometric Information System“ (ABIS) stehen nicht in Afghanistan, sondern
                    in West Virginia in den USA.
                </Slide>
                <Slide position={Position.RIGHT} trigger={{ drawLines: [{ source: 'scanner', target: 'server_1' }] }}>
                    Mit dieser Datenbank verbinden sich die Geräte im Einsatz regelmäßig und laden alle aufgenommenen
                    Daten hoch.
                </Slide>
                <Slide position={Position.RIGHT} trigger={{ camera: boardConfig.cameraConfigs['server'] }}>
                    ABIS enthält Millionen „Identitäten“ von Menschen, deren Daten von US-Militärs in Kriegseinsätzen
                    auf der ganzen Welt aufgenommen wurden.
                </Slide>
                <Slide
                    position={Position.RIGHT}
                    trigger={{
                        changeMaterial: {
                            meshId: 'server_display',
                            materialName: 'display/server_display_terrorist.jpg'
                        }
                    }}
                >
                    Die Einträge enthalten auch Gefährdungslevel. Wenn zum Beispiel Gefährdungslevel 1 („detain“)
                    eingetragen ist, wird die Person als gefährlich eingestuft und soll festgehalten werden. Bei 2
                    („question“) soll die Person befragt und bei 4 („disqualify“) soll ihr der Zugang zu
                    Militärstützpunkten verboten werden.
                </Slide>
                <Slide
                    position={Position.RIGHT}
                    trigger={{
                        camera: boardConfig.cameraConfigs['server_data_close'],
                        drawLines: [{ source: 'server_1', target: 'scanner' }]
                    }}
                >
                    Alle paar Tage sollten Soldatinnen und Soldaten lange Listen mit solchen gesuchten Personen auf die
                    Geräte herunterladen. Der Grund: In Afghanistan war die Internetverbindung oft zu schlecht für eine
                    verlässliche Verbindung mit ABIS in den USA.
                </Slide>
                <Slide
                    position={Position.RIGHT}
                    trigger={{
                        camera: boardConfig.cameraConfigs['server_data'],
                        fade: ['server_2', 'server_3'],
                        drawLines: [
                            { source: 'server_1', target: 'server_2' },
                            { source: 'server_3', target: 'server_1' },
                            { source: 'server_2', target: 'server_3' }
                        ]
                    }}
                >
                    Möglicherweise stammten die Daten, die so auf den Geräten landeten, nicht nur aus ABIS, sondern auch
                    aus Datenbanken des FBI, des Departments of Homeland Security und des Department of Justice. Denn
                    mit diesen Datenbanken ist ABIS verknüpft.
                </Slide>
            </Scrolly>
            <Section>
                <Block>
                    <P>
                        Angestoßen von den USA haben die internationalen Truppen unter Führung der Nato das Ziel
                        verfolgt, möglichst die gesamte Bevölkerung Afghanistans biometrisch zu erfassen. Auf diese
                        Weise wollten sie in Afghanistan „Identity Dominance“ erlangen, wie die Amerikaner diese
                        Strategie der Kriegsführung nennen. Je schneller man alle Menschen erfasse, umso schneller könne
                        man sämtliche Attentäter vom Schlachtfeld entfernen, heißt es in einem Biometrie-Handbuch des
                        US-Militärs. Dafür setzten US-Truppen in Afghanistan mehrere Tausend solcher Geräte ein und
                        scannten Millionen Menschen. Auch Soldatinnen und Soldaten der Bundeswehr nahmen damit
                        biometrische Daten von Menschen in Afghanistan auf.
                    </P>

                    <LazyImage
                        src={ImageScanner}
                        width={900}
                        height={1200}
                        note="Unter anderem solche Geräte hat Matthias Marx untersucht. Bild: BR/Rebecca Ciesielski"
                    />

                    <P>
                        In Afghanistan war Biometrie in den vergangenen Jahren allgegenwärtig. Wenn Menschen zur Wahl
                        gingen, Zugang zu Armeebasen hatten, bei der Polizei oder in Schulen arbeiten wollten, dann
                        wurden ihre Identitäten überprüft und ihre biometrischen Daten gespeichert. Ein ehemaliger hoher
                        Beamter des afghanischen Innenministeriums bestätigt uns: Sehr viele dieser Daten sind letztlich
                        in ABIS in den USA gelandet. Auch Daten, die nicht von internationalen Truppen, sondern von
                        afghanischen Behörden aufgenommen wurden. Möglicherweise befinden sich deshalb auch die Daten
                        von Shir Entezar in ABIS. Der Beamte hält das für wahrscheinlich. Falls seine Daten auf die
                        Geräte und in die Hände der Taliban gelangt sind, ist die Familie in großer Gefahr.
                    </P>
                    <H2>Shir Entezars Familie versteckt sich seit Monaten</H2>

                    <P>
                        Als wir wieder mit Shir Entezar sprechen, haben er, seine Frau und seine Kinder ihr Versteck
                        erneut gewechselt. Im Herbst 2022 scheint ihre Situation immer bedrohlicher zu werden. Zu diesem
                        Zeitpunkt versucht er mit seiner Familie seit über einem Jahr aus Afghanistan zu fliehen. Über
                        eine deutsche NGO hatte er einen Antrag auf Ausreise an die Bundesregierung gestellt, doch
                        monatelang hört er nichts. „Ich warte auf eine positive Antwort von Deutschland, die mein Leben
                        retten kann.“
                    </P>
                    <H2>Unzählige Fotos, Iris-Scans und Fingerabdrücke</H2>

                    <P>
                        Matthias Marx hat unterdessen weitere Geräte auf Ebay gekauft. Insgesamt fünf davon hat er
                        inzwischen analysiert. Und auf einem davon einen spektakulären Fund gemacht: Tausende geheime
                        Daten des US-Militärs. Er hat den kompletten Inhalt des Geräts auf seinen Laptop kopiert und
                        zeigt uns Fotos von Menschen, die nicht besonders glücklich in die Kamera blicken. Die meisten
                        haben dunkle Haare, viele tragen einen Bart und manche stecken in orangefarbenen Overalls, wie
                        man sie aus Guantanamo kennt.
                    </P>
                </Block>
            </Section>
            <Scrolly>
                <Slide
                    position={Position.RIGHT}
                    trigger={{
                        camera: boardConfig.cameraConfigs['hacker_info_close'],
                        fade: ['hacker_info'],
                        changeMaterial: { meshId: 'display', materialName: 'display/scanner_display_info.jpg' }
                    }}
                >
                    Matthias Marx findet auf einem der Geräte eine große Datenbank mit Informationen. Biometrische Daten
                    von 2600 Personen – die meisten davon aus den Einsätzen in Afghanistan und dem Irak. Darunter
                    Tausende Iris-Scans, Fingerabdrücke und Fotos.
                </Slide>
                <Slide
                    position={Position.RIGHT}
                    trigger={{ camera: boardConfig.cameraConfigs['info'], fade: ['human', 'head', 'info'] }}
                >
                    Neben biometrischen Daten enthalten die Geräte auch Informationen über die erfassten Personen:
                    Größe, Gewicht, Geburtsdaten und vieles mehr.
                </Slide>
                <Slide
                    position={Position.RIGHT}
                    trigger={{
                        fade: ['info_description_terrorist'],
                        camera: boardConfig.cameraConfigs['info_close'],
                        changeMaterial: { meshId: 'display', materialName: 'display/scanner_display_terrorist.jpg' }
                    }}
                >
                    Bei einem Teil der Daten handelt es sich offenbar um gesuchte Terroristen, die auf einer
                    Beobachtungsliste des US-Verteidigungsministeriums stehen. Andere Daten wurden wohl im Einsatz mit
                    dem Gerät selbst aufgezeichnet, etwa an Kontrollpunkten des US-Militärs.
                </Slide>
                <Slide
                    position={Position.RIGHT}
                    trigger={{
                        fade: ['info_description_terrorist', 'info', 'info_national_police', 'info_description_police'],
                        camera: boardConfig.cameraConfigs['info_close'],
                        changeMaterial: { meshId: 'display', materialName: 'display/scanner_display_profiles.jpg' }
                    }}
                >
                    Ein Fund ist besonders brisant: Manche der Personen in den Daten werden eindeutig als Freiwillige,
                    als ehemalige Mitglieder der Polizei oder des Militärs ausgewiesen. Das verraten Einträge wie
                    „Volunteer Background Checks", "ECP Base Access“, „National Security Forces Screening“, „Host Nation
                    Police" oder „Host Nation Military“.
                </Slide>
                <Slide
                    position={Position.RIGHT}
                    trigger={{
                        camera: boardConfig.cameraConfigs['hacker_info_close'],
                        fade: ['info_description_last_usage'],
                        changeMaterial: { meshId: 'display', materialName: 'display/scanner_display_afghanistan.jpg' }
                    }}
                >
                    Laut GPS-Koordinaten, die sich auf dem Gerät befinden, wurde es im Jahr 2012 in der südafghanischen
                    Provinz Zabul eingesetzt.
                </Slide>
            </Scrolly>

            <Section>
                <Block>
                    <H2>Der Beweis: Die Geräte bringen Menschen in Lebensgefahr</H2>
                    <P>
                        Diese Informationen auf den Biometrie-Scannern können im Zweifel über Leben und Tod entscheiden.
                        Denn hätten die Taliban ein solches Gerät in der Hand, könnten sie damit Personen eindeutig als
                        Unterstützerinnen und Unterstützer der früheren afghanischen Regierung oder der internationalen
                        Truppen identifizieren. Also als Menschen, die sie als ihre Feinde betrachten. Das war es,
                        wonach Matthias Marx gesucht hatte. Damit ist der endgültige Beweis erbracht, wie gefährlich die
                        Geräte sind, die vor allem die USA aber auch andere internationale Truppen unter Nato-Führung in
                        Afghanistan eingesetzt und zurückgelassen haben.
                    </P>
                    <LazyImage
                        src={ImageMatthiasLaptop}
                        width={900}
                        height={675}
                        note="Matthias Marx zeigt die Daten auf seinem Laptop. Bild: NDR/Svea Eckert"
                    />
                    <P>
                        „Die US-Regierung muss zur Verantwortung gezogen werden“, sagt Belkis Wille, als wir ihr von dem
                        erzählen, was Matthias Marx herausgefunden hat. Sie ist Krisen- und Konfliktforscherin bei der
                        NGO Human Rights Watch und hat in einem Bericht vor den Gefahren der Biometrie-Geräte gewarnt.
                        Zu den neuen Erkenntnissen sagt sie: „Jetzt ist klar, dass diese Geräte absolut unsicher und für
                        den Einsatz in Afghanistan ungeeignet sind“. Angesichts der Sicherheitssituation in dem Land sei
                        es „höchst leichtsinnig“ gewesen, dort solche Geräte einzusetzen. Sie fordert die US-Regierung
                        auf, umgehend zu handeln. Gefährdete Menschen müssten die Möglichkeit bekommen, auszureisen und
                        Asyl zu beantragen. „Biometrische Daten lassen sich nicht löschen. Die bleiben für immer.“
                        Früher hätten etwa ehemalige Polizistinnen und Polizisten auf der Flucht vor den Taliban ihre
                        Namen ändern können, um sich zu verstecken. Das reiche nun nicht mehr: „Diese Geräte sorgen
                        dafür, dass diese Menschen keine Chance haben, sich zu schützen.“
                    </P>
                    <LazyImage
                        src={ImageOriginalScreen}
                        width={800}
                        height={480}
                        note="Original-Screenshot von einem Gerät mit Kategorien wie „Host Nation Military“"
                    />
                    <H2>Geheimes Abkommen zum Umgang mit Daten</H2>

                    <P>
                        Manche der Daten zeigen, dass außer den USA auch andere Truppen in Afghanistan biometrische
                        Daten erfasst haben: In einem Feld steht zum Beispiel „UK“ und eine britische Telefonnummer, in
                        einem anderen „kanadisch“. Einer der Datensätze enthält das Kürzel „GER“. Könnten von der
                        Bundeswehr gesammelte Daten auf dem Gerät gelandet sein? Wikileaks veröffentlichte schon vor
                        einigen Jahren eine ursprünglich geheime Vereinbarung. Das Memorandum wurde zwischen dem
                        Department of Defense der USA und dem deutschen Verteidigungsministerium geschlossen und regelt
                        den Umgang der USA mit den Daten, die in Afghanistan von Deutschen erhoben wurden. Die Daten
                        sollen in einer „gesicherten technischen Umgebung“ gespeichert und nach Ende des
                        Afghanistan-Einsatzes gelöscht werden. „Insbesondere“, heißt es dort:
                    </P>
                    <Paper signature={'Memorandum of Understanding zwischen USA und Deutschland aus dem Jahr 2011'}>
                        „soll [...] sichergestellt werden, dass die von der Bundeswehr gesammelten Daten nicht im
                        Zusammenhang mit willkürlichen Festnahmen und Verfolgungen oder Misshandlungen von Personen
                        verwendet werden“.
                    </Paper>
                    <P>
                        Nach allem, was Matthias Marx herausgefunden hat, ist zu befürchten, dass genau das passieren
                        könnte. Und dass auch von Deutschen erhobene Daten Menschen in Lebensgefahr bringen könnten.
                    </P>
                    <P>
                        Das Bundesverteidigungsministerium teilt dem BR mit, es lägen keine Informationen zu dem
                        Sachverhalt vor. Von der Bundeswehr genutzte Geräte seien mit Missionsende an die
                        Nato-Missionsführung zurückgegeben worden. Das US-Verteidigungsministerium gibt auf Anfrage an,
                        man habe dem afghanischen Militär 1200 Biometrie-Geräte übergeben. Ursprünglich seien diese
                        Geräte in der Lage gewesen, sich mit Biometrie-Datenbanken in den USA zu verbinden. Eine solche
                        Datenübertragung sei inzwischen nicht mehr möglich. Wie viele Geräte Soldatinnen und Soldaten in
                        Afghanistan einsetzten, wie viele davon dortgeblieben sind und warum sich darauf noch Daten
                        befinden, erfahren wir von niemandem. Nicht vom US-Verteidigungsministerium, nicht von der Nato
                        und auch nicht von der deutschen Regierung. Wir erfahren auch nicht, warum Matthias Marx einige
                        dieser Geräte auf Ebay kaufen konnte.
                    </P>
                    <LazyImage
                        src={ImageSaid}
                        width={900}
                        height={675}
                        note="Shir Entezar im Dezember 2022 in Deutschland. Bild: BR/Rebecca Ciesielski"
                    />
                    <H2>Shir Entezar darf ausreisen – viele andere nicht</H2>
                    <P>
                        Im November 2022 meldet sich Shir Entezar erneut. Nach vielen Monaten des Wartens hat er die
                        Zusage für eine Aufnahme in Deutschland bekommen. Einige Wochen später ist die Familie in
                        Sicherheit. Aber er ist offenbar eine Ausnahme, viele seiner ehemaligen Kollegen sind weiterhin
                        in Afghanistan und fürchten um ihr Leben. „Hunderte meiner ehemaligen Kolleginnen und Kollegen
                        sind abgelehnt worden. Ich mache mir große Sorgen, weil sie weiterhin in Gefahr sind - obwohl
                        unsere Fälle ja gleich sind.“ Als wir ihm von dem Fund von Matthias Marx erzählen, wird er
                        emotional: „Ich bin so traurig darüber, dass Deutschland, die Nato und die USA alle diese
                        biometrischen Geräte in Afghanistan zurückgelassen haben. Damit haben sie Menschen in
                        Lebensgefahr gebracht.“
                    </P>
                </Block>
                <Block>
                    <InfoBox>
                        <H2>Über das Projekt:</H2>
                        <P>
                            Dies ist ein Projekt des Bayerischen Rundfunks (BR Data, AI + Automation Lab und BR
                            Recherche).
                        </P>
                        <List>
                            <ListItem>
                                Auch die{' '}
                                <A
                                    href="https://www.nytimes.com/2022/12/27/technology/for-sale-on-ebay-a-military-database-of-fingerprints-and-iris-scans.html"
                                    rel="noopener noreferrer"
                                    target="_blank"
                                >
                                    New York Times
                                </A>{' '}
                                berichtet über den Fall.
                            </ListItem>
                            <ListItem>
                                Zu einem ausführlichen Blogpost des Chaos Computer Clubs geht es{' '}
                                <A
                                    href="https://www.ccc.de/de/updates/2022/afghanistan-biometrie"
                                    rel="noopener noreferrer"
                                    target="_blank"
                                >
                                    hier
                                </A>
                                .
                            </ListItem>
                        </List>
                        <List>
                            <ListItem>
                                <b>Autoren: </b>
                                {mainConfig.authors.join(', ')}
                            </ListItem>
                            <ListItem>
                                <b>Digitales Design: </b>Steffen Kühne, Sebastian Bayerl
                            </ListItem>
                            <ListItem>
                                <b>Redaktion: </b> Robert Schöffel, Helga van Ooijen
                            </ListItem>
                        </List>
                        <P>Veröffentlicht am 27.12.2022</P>
                    </InfoBox>
                </Block>

                <Block>
                    <LazyLoadComponent>
                        <H2>Das könnte Sie auch interessieren:</H2>
                        <RelatedContent>
                            <Teaser
                                timestamp="27.12.2022, 08:00 Uhr"
                                title="ARD-Radiofeature: Verräterische Daten"
                                text="Das ausführliche ARD-Radiofeature „Verräterische Daten: Doku über die Gefahren von Biometrie“ in der ARD Audiothek"
                                href="https://www.ardaudiothek.de/sendung/das-ard-radiofeature/72633432/"
                                img={
                                    'https://img.br.de/4ce05d55-248a-41b9-b809-02587a429314.jpeg?rect=0,289,5760,3238&w=1024&q=90'
                                }
                                alt="Das ARD-Radiofeature"
                            />
                            <Teaser
                                timestamp="17.5.2022, 5:46 Uhr"
                                title="Afghanistan: Helfer in Lebensgefahr"
                                text="Die Regierung hat versprochen, gefährdete Personen vor den Taliban in Sicherheit zu bringen. Afghanische Ex-Mitarbeiter der Entwicklungshilfeagentur GIZ fallen aber durchs Raster. BR-Recherchen zeigen: Sie sind in größerer Gefahr als bislang bekannt."
                                href="https://www.br.de/nachrichten/deutschland-welt/afghanistan-deutschlands-helfer-in-lebensgefahr,T61CvtO"
                                img={
                                    'https://img.br.de/648aa322-f616-4654-bed5-19130f2a828d.jpeg?rect=0,289,5760,3238&w=1024&q=90'
                                }
                                alt="BR24 Afghanistan: Deutschlands Helfer in Lebensgefahr"
                            />
                            <Teaser
                                timestamp="27.12.2022, 06:00 Uhr"
                                title="Podcast: She Likes Tech"
                                text="BR-Reporterin Rebecca Ciesielski zu Gast im Tech-Podcast „She Likes Tech“ mit Svea Eckert zum Thema Biometrie in der ARD Audiothek"
                                href="https://www.ardaudiothek.de/sendung/she-likes-tech-der-podcast-ueber-technologie/80042936/"
                                img={'https://www.ndr.de/mediathek/podcast4812_v-contentxl.jpg'}
                                alt="Zur Podcast-Folge von She likes tech"
                            />
                        </RelatedContent>
                    </LazyLoadComponent>
                </Block>
            </Section>
        </Article>
    );
};
